import React, { useRef, useState } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { PATHIS, PREACHERS, MONTHS_HI, withHonorific } from "../data/rssbData";
import { UserX, FileUp, FolderOpen, Loader2 } from "lucide-react";

const LeaveDialog = ({ open, onClose, leave, onSave, monthLabel }) => {
  const [sel, setSel] = useState(new Set(leave));
  const [q, setQ] = useState("");
  React.useEffect(() => {
    if (open) setSel(new Set(leave));
  }, [open, leave]);
  const people = [...PREACHERS.map((p) => ({ p, r: p.role })), ...PATHIS.map((p) => ({ p, r: "पाठी" }))].filter(
    ({ p }) => !q || p.hi.includes(q) || (p.en || "").toLowerCase().includes(q.toLowerCase()) || (p.placeHi || "").includes(q)
  );
  const toggle = (id) => setSel((s) => {
    const n = new Set(s);
    n.has(id) ? n.delete(id) : n.add(id);
    return n;
  });
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#fffdf7] border-[#6e1b1b]/40 text-[#3a1212] max-h-[90vh] flex flex-col" data-testid="leave-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif-dev">छुट्टी पर सेवादार — {monthLabel}</DialogTitle>
          <DialogDescription className="text-xs text-[#7a4a3a] font-dev">चुने गए सेवादारों को इस माह कोई सत्संग सेवा नहीं दी जाएगी (अगली बार शेड्यूल बनाने पर लागू)।</DialogDescription>
        </DialogHeader>
        <Input data-testid="leave-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="नाम या स्थान खोजें..." className="bg-[#f6eeda] border-[#e3d6b6] font-dev" />
        <div className="flex-1 overflow-y-auto space-y-1 pr-1 min-h-[200px]">
          {people.map(({ p, r }) => (
            <label key={p.id} data-testid={`leave-item-${p.id}`} className={`flex items-center gap-2 px-3 py-2 rounded-md border cursor-pointer font-dev text-sm ${sel.has(p.id) ? "bg-[#f7e9e4] border-[#6e1b1b]/50" : "bg-[#fffdf7] border-[#e3d6b6]"}`}>
              <input type="checkbox" checked={sel.has(p.id)} onChange={() => toggle(p.id)} className="accent-[#6e1b1b] w-4 h-4" />
              <span className="font-semibold">{withHonorific(p)}</span>
              <span className="text-[11px] text-[#7a4a3a]">{r} · {p.placeHi}</span>
            </label>
          ))}
        </div>
        <DialogFooter className="gap-2">
          <span className="text-xs text-[#6e1b1b] font-dev mr-auto self-center">{sel.size} चुने गए</span>
          <Button variant="ghost" onClick={onClose} className="text-[#5a2a24]">रद्द करें</Button>
          <Button data-testid="leave-save" onClick={() => onSave([...sel])} className="bg-[#6e1b1b] text-[#f3ead6] hover:bg-[#7a1f1f]">सहेजें</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

// Quick actions shown above the planner: leave, edit an existing PDF schedule, saved schedules.
export const PlannerToolbar = ({ year, month, leave, onSaveLeave, onImportPdf, importing, onOpenSaved, savedCount }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const btn = "border-[#6e1b1b]/50 text-[#6e1b1b] bg-[#fffdf7] hover:bg-[#6e1b1b]/10 gap-2 font-dev";
  return (
    <div className="flex flex-wrap gap-2 mb-4" data-testid="planner-toolbar">
      <Button data-testid="leave-btn" variant="outline" className={btn} onClick={() => setOpen(true)}>
        <UserX className="w-4 h-4" /> छुट्टी पर सेवादार ({leave.length})
      </Button>
      <Button data-testid="import-pdf-btn" variant="outline" className={btn} disabled={importing} onClick={() => ref.current?.click()}>
        {importing ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileUp className="w-4 h-4" />} मौजूदा शेड्यूल बदलें (PDF अपलोड)
      </Button>
      <input ref={ref} type="file" accept=".pdf" className="hidden" data-testid="import-pdf-input" onChange={(e) => { const f = e.target.files?.[0]; if (f) onImportPdf(f); e.target.value = ""; }} />
      <Button data-testid="open-saved-btn" variant="outline" className={btn} onClick={onOpenSaved}>
        <FolderOpen className="w-4 h-4" /> सहेजे गए शेड्यूल ({savedCount})
      </Button>
      <LeaveDialog open={open} onClose={() => setOpen(false)} leave={leave} monthLabel={`${MONTHS_HI[month]} ${year}`} onSave={(ids) => { onSaveLeave(ids); setOpen(false); }} />
    </div>
  );
};
